import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const DocumentText = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.6666 6.66665V9.99998C14.6666 13.3333 13.3333 14.6666 9.99992 14.6666H5.99992C2.66659 14.6666 1.33325 13.3333 1.33325 9.99998V5.99998C1.33325 2.66665 2.66659 1.33331 5.99992 1.33331H9.33325"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6666 6.66665H11.9999C9.99992 6.66665 9.33325 5.99998 9.33325 3.99998V1.33331L14.6666 6.66665Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66675 8.66669H8.66675"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66675 11.3333H7.33342"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

DocumentText.displayName = 'DocumentText';
